import React from "react";

// Tiny utility "Reveal" wrapper using IntersectionObserver — no heavy deps
export function Reveal({ children, delay = 0, className = "", as: Tag = "div", ...rest }) {
  const ref = React.useRef(null);
  const [shown, setShown] = React.useState(false);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setShown(true); obs.disconnect(); } },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      style={{ transitionDelay: `${delay}ms` }}
      className={`transition-all duration-700 ease-out will-change-transform ${
        shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      } ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export function SectionLabel({ children, className = "" }) {
  return (
    <p className={`font-mono text-[10px] uppercase tracking-[0.28em] text-[#C44900] mb-5 flex items-center gap-3 ${className}`}>
      <span className="w-6 h-px bg-[#C44900]" /> {children}
    </p>
  );
}

export function StatBlock({ value, label, hint }) {
  return (
    <div className="border-t border-[#E5E5E0] pt-5">
      <div className="font-display font-bold tracking-tighter text-4xl sm:text-5xl text-[#111A15] leading-none">{value}</div>
      <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#4A5E51] mt-3">{label}</div>
      {hint && <div className="text-[12px] text-[#4A5E51] mt-1">{hint}</div>}
    </div>
  );
}
